/* eslint-disable no-unused-vars */
import React from 'react'
import {Typography,Grid} from '@mui/material';
import {PersonOutline} from '@material-ui/icons';
import useStyles from './styles';
const CommentItem = ({comment}) => {
  const classes =useStyles();
  return (
    <div className={classes.commentItem}>
    <div className={classes.commentsItemPrimary}>
    <Grid container justifyContent={'space-between'}>
      <Grid item xs={12} sm={12} md={12} lg={12} >
      <Grid container justifyContent={'flex-start'} spacing={1}>
          <Grid item>
         <Grid container  justifyContent="flex-start">
         <Grid item> @{/* <PersonOutline  /> */}</Grid>
         <Grid item >
          <Typography  className={classes.username} variant='caption' >{comment.username}</Typography>
             </Grid>
           </Grid>
          </Grid>
         
       </Grid>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
      <Typography align='left' className={classes.text} variant='body2'>
      {comment.text}
    </Typography>
      </Grid>
    
     </Grid>
   
    </div>
   <div className={classes.commentsItemSecondary}>
   <Typography variant='body2' style={{fontSize:'10px',color:'darkgray'}}>{new Date(comment.dateCreated).toDateString()}</Typography>
   </div>
 </div>
  )
}

export default CommentItem
